import { render, staticRenderFns } from "./tabCustomsInfoUICustomLayout.vue?vue&type=template&id=15fef580&"
import script from "./tabCustomsInfoUICustomLayout.vue?vue&type=script&lang=js&"
export * from "./tabCustomsInfoUICustomLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15fef580')) {
      api.createRecord('15fef580', component.options)
    } else {
      api.reload('15fef580', component.options)
    }
    module.hot.accept("./tabCustomsInfoUICustomLayout.vue?vue&type=template&id=15fef580&", function () {
      api.rerender('15fef580', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cargo/Job/booking/tabs/tabCustomsInfoUICustomLayout.vue"
export default component.exports